/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import { Alert, AlertDescription, AlertTitle } from '@e2n/ui';
import { useMindestbelegung } from '@/domain/controlling/hooks/useMindestbelegung/useMindestbelegung';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { useDialogContext } from '@/domain/controlling/pages/Umsatzplanung/Planung/Dialog/DialogContext';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { getHoursAndMinutesFromMinutes } from '@/utils';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Mindestbelegung({ datum }: { datum: string }) {
  const { t } = useTranslation();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const mindestbelegungDauer = useMindestbelegung(datum, standortId) ?? 0;
  const mindestbelegungStunden =
    getHoursAndMinutesFromMinutes(mindestbelegungDauer);
  const { umsatzplanungAnzeige } = useTagebuchEinstellungen(standortId);

  const { planwerteForm } = useDialogContext();
  const absatzZielminuten = planwerteForm.formValues.absatzZielminuten ?? 0;
  const umsatzZielminuten = planwerteForm.formValues.umsatzZielminuten ?? 0;

  if (
    umsatzplanungAnzeige === 'ABSATZ_PRODUKTIVITAET' &&
    absatzZielminuten &&
    absatzZielminuten < mindestbelegungDauer
  ) {
    const absatzZielstunden = getHoursAndMinutesFromMinutes(absatzZielminuten);
    const description = t(
      'domain.controlling.umsatzplanung.planung.mindestbelegung.description',
      {
        zielstunden: `${absatzZielstunden.hours} Std. ${absatzZielstunden.minutes} Min.`,
        mindestbelegung: `${mindestbelegungStunden.hours} Std. ${mindestbelegungStunden.minutes} Min.`,
      },
    );
    return <MindestbelegungAlert description={description} />;
  } else if (
    umsatzplanungAnzeige === 'UMSATZ_PRODUKTIVITAET' &&
    umsatzZielminuten &&
    umsatzZielminuten < mindestbelegungDauer
  ) {
    const umsatzZielstunden = getHoursAndMinutesFromMinutes(umsatzZielminuten);
    const description = t(
      'domain.controlling.umsatzplanung.planung.mindestbelegung.description',
      {
        zielstunden: `${umsatzZielstunden.hours} Std. ${umsatzZielstunden.minutes} Min.`,
        mindestbelegung: `${mindestbelegungStunden.hours} Std. ${mindestbelegungStunden.minutes} Min.`,
      },
    );
    return <MindestbelegungAlert description={description} />;
  } else if (
    (umsatzplanungAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' &&
      absatzZielminuten &&
      absatzZielminuten < mindestbelegungDauer) ||
    (umsatzZielminuten && umsatzZielminuten < mindestbelegungDauer)
  ) {
    const umsatzZielstunden = getHoursAndMinutesFromMinutes(umsatzZielminuten);
    const absatzZielstunden = getHoursAndMinutesFromMinutes(absatzZielminuten);

    let description = '';
    if (
      umsatzZielminuten < mindestbelegungDauer &&
      absatzZielminuten < mindestbelegungDauer
    ) {
      description = t(
        'domain.controlling.umsatzplanung.planung.mindestbelegung.descriptionUmsatzAbsatz',
        {
          umsatzZielstunden: `${umsatzZielstunden.hours} Std. ${umsatzZielstunden.minutes} Min.`,
          absatzZielstunden: `${absatzZielstunden.hours} Std. ${absatzZielstunden.minutes} Min.`,
          mindestbelegung: `${mindestbelegungStunden.hours} Std. ${mindestbelegungStunden.minutes} Min.`,
        },
      );
    } else if (umsatzZielminuten < mindestbelegungDauer) {
      description = t(
        'domain.controlling.umsatzplanung.planung.mindestbelegung.descriptionUmsatz',
        {
          umsatzZielstunden: `${umsatzZielstunden.hours} Std. ${umsatzZielstunden.minutes} Min.`,
          mindestbelegung: `${mindestbelegungStunden.hours} Std. ${mindestbelegungStunden.minutes} Min.`,
        },
      );
    } else {
      description = t(
        'domain.controlling.umsatzplanung.planung.mindestbelegung.descriptionAbsatz',
        {
          absatzZielstunden: `${absatzZielstunden.hours} Std. ${absatzZielstunden.minutes} Min.`,
          mindestbelegung: `${mindestbelegungStunden.hours} Std. ${mindestbelegungStunden.minutes} Min.`,
        },
      );
    }
    return <MindestbelegungAlert description={description} />;
  } else {
    return <></>;
  }
}

function MindestbelegungAlert({ description }: { description: string }) {
  const { t } = useTranslation();

  return (
    <Alert variant="warning">
      <FontAwesomeIcon icon={faTriangleExclamation} />
      <AlertTitle>
        {t('domain.controlling.umsatzplanung.planung.mindestbelegung.title')}
      </AlertTitle>
      <AlertDescription>{description}</AlertDescription>
    </Alert>
  );
}
